import { render } from "./NotificationsFilter.vue?vue&type=template&id=2635797d&lang=pug"
import script from "./NotificationsFilter.vue?vue&type=script&lang=js"
export * from "./NotificationsFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__